import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const subNavigationStyles = {
    subNavigationContainer: {
        backgroundColor: colors.background.white,
        width: '100%',
        boxSizing: 'border-box',
        maxHeight: '6.4rem',
        borderBottom: '1px solid #D9E1E8',
        [`@media (max-width: ${breakpoints.md})`]: {
            maxHeight: 'unset',
            borderBottom: 'none',
        },
    },
    subNavigation: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        boxSizing: 'border-box',
        maxWidth: 1630,
        margin: '0 auto',
        minHeight: '6.4rem',
        maxHeight: '6.4rem',
        '@media (max-width: 1679.9px)': {
            paddingLeft: '3.6rem ',
            paddingRight: '3.6rem ',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            overflowX: 'hidden',
        },
    },
    smallLeftMarginIcon: {
        marginLeft: '0.5rem',
    },
    arrowContainer: {
        margin: '0 1.6rem',
    },
    buttonContainer: {
        margin: '0 .8rem',
        maxHeight: '4.2rem',
    },
    buttonItem: {
        width: '100%',
        padding: '.4rem 2.4rem !important',
        borderRadius: '.8rem',
        minHeight: '4.2rem',
    },
    buttonDivider: {
        marginRight: '2rem',
        borderLeft: '2px solid #C0CCD8',
        height: '2.6rem',
    },
    linkItemContainer: {
        overflow: 'auto',
        scrollbarWidth: 'none',
    },
    linkItem: {
        color: colors.text.activePrimary,
        padding: '.8rem 1.6rem',
        margin: '0 1.6rem',
        fontWeight: 500,
        fontSize: '1.8rem',
        textDecoration: 'none',
        borderRadius: '.8rem',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: `${colors.core.cloud} !important`,
            color: colors.text.activeSecondary,
            padding: '.8rem 1.6rem',
        },
        '&:focus-visible': {
            outline: 'none',
            textDecoration: 'underline',
            backgroundColor: `${colors.core.cloud} !important`,
            color: colors.text.activeSecondary,
            padding: '.8rem 1.6rem',
        },
    },
    arrowButton: {
        '&:hover': {
            backgroundColor: `${colors.core.cloud} !important`,
            color: colors.text.activeSecondary,
        },
    },
    flipArrow: {
        transform: 'scaleX(-1)',
    },
} as const;
